import React from 'react';
import styled from 'styled-components' ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Services = (props) => {
   const icon = props.icon
   return(
      <Caja>
         <FontAwesomeIcon className="icono" icon={icon}/>         
         <h2>{props.name}</h2>
         <p> {props.description} </p>
      </Caja>
   );

}
export default Services;

const Caja = styled.div`
  height: 100%;
  min-width: 16rem;
  padding: 10px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 5px;
  max-width: 100%;

  h2 {
    font-size: 1.4rem;
  }

  .icono {
    background-color: #e1e1e1;
    color: #003c70;
    width: 3rem;
    height: 3rem;
    padding: 10px;
    border-radius: 100%;
  }
`